import { render, staticRenderFns } from "./WelcomeModule.vue?vue&type=template&id=42c7fab6&scoped=true"
import script from "./WelcomeModule.vue?vue&type=script&lang=js"
export * from "./WelcomeModule.vue?vue&type=script&lang=js"
import style0 from "./WelcomeModule.vue?vue&type=style&index=0&id=42c7fab6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c7fab6",
  null
  
)

export default component.exports